import { render, staticRenderFns } from "./PurchaseTemplate.vue?vue&type=template&id=1ee5d69a&scoped=true&"
import script from "./PurchaseTemplate.vue?vue&type=script&lang=js&"
export * from "./PurchaseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseTemplate.vue?vue&type=style&index=0&id=1ee5d69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5d69a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
